import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import * as jobSearchDuck from '../jobSearchDuck'
import { connect } from 'react-redux'
import Rodal from 'rodal'
import get from 'lodash/get'
import JobPostingDescription from './JobPostingDescription'
import selectors from '../../../../store/shared/selectors'
import JobPostingErrorWrapper from './JobPostingErrorWrapper'

class JobPostingDetail extends Component {
  render() {
    const {
      jobDetailsModalShown,
      toggleJobDetailsModal,
      jobPostingDetails,
      selectedJobPosting,
      loadingJobPostingDetails,
      isMobile,
    } = this.props

    const title = get(selectedJobPosting, 'title')
    const companyName = get(selectedJobPosting, 'company_name')
    const description = get(selectedJobPosting, 'description')
    // The SERP API changes frequently. Check both data sources for apply options
    const applyOptions = get(selectedJobPosting, 'apply_options') ? get(selectedJobPosting, 'apply_options') : get(jobPostingDetails, 'apply_options', [])

    return (
      <Rodal
        width="unset"
        height="unset"
        visible={jobDetailsModalShown}
        onClose={toggleJobDetailsModal}
        animation="zoom"
        showMask={true}
        closeOnEsc={true}
        closeMaskOnClick={true}
        customStyles={{ maxWidth: isMobile ? '95%' : '80%', maxHeight: isMobile ? '95%' : '80%' }}
        destroyOnClose={true}
      >
        <div className={`d-flex flex-column h-100 ${isMobile ? 'overflow-auto' : 'p-4'}`}>
          <h2>{title}</h2>
          <p>{companyName}</p>
          <div className="dropdown-divider" />
          <JobPostingErrorWrapper>
            <h3>Apply options</h3>
            {loadingJobPostingDetails ? (
              <div className="d-flex justify-content-center">
                <div className="spinner-border text-success" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            ) : (
              <div className="d-flex flex-wrap mb-2" style={{ maxHeight: 200, overflow: 'auto' }}>
                {applyOptions && applyOptions.length ? (
                  applyOptions.map(applyOption => (
                    <a
                      key={applyOption.title}
                      href={applyOption.link}
                      target="_blank"
                      className="btn btn-primary px-2 mr-3 mb-2"
                    >
                      {applyOption.title}
                    </a>
                  ))
                ) : (
                  <p className="text-muted">There are no apply options available at this time.</p>
                )}
              </div>
            )}
            <div className="dropdown-divider" />
            <h3>Job Description</h3>
            {loadingJobPostingDetails ? (
              <div className="d-flex justify-content-center">
                <div className="spinner-border text-success" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            ) : (
              <JobPostingDescription description={description} />
            )}
          </JobPostingErrorWrapper>
        </div>
      </Rodal>
    )
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      toggleJobDetailsModal: jobSearchDuck.toggleJobDetailsModal,
    },
    dispatch,
  )

const mapStateToProps = state => ({
  jobDetailsModalShown: state.jobSearch.jobDetailsModalShown,
  loadingJobPostingDetails: state.jobSearch.loadingJobPostingDetails,
  selectedJobPosting: state.jobSearch.selectedJobPosting,
  jobPostingDetails: state.jobSearch.jobPostingDetails,
  isMobile: selectors.isLessThanMedium(state),
})

export default connect(mapStateToProps, mapDispatchToProps)(JobPostingDetail)



// WEBPACK FOOTER //
// ./src/routes/authenticated/JobSearch/components/JobPostingDetail.js